function RESET_STORE() {
	return { type: "RESET_STORE" }
}

function SET_METATAG(dataStore = null, staticMeta = null, page = null) {
	let returnVal = { type: "SET_METATAG", page, staticMeta }

	return dataStore !== null
		? { ...returnVal, payload: dataStore.payload, statusCode: dataStore.statusCode }
		: { ...returnVal, payload: {}, statusCode: 200 }
}

export { RESET_STORE, SET_METATAG }
